import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { AssetCategoryActions } from '../actions/asset-category.actions';
import { AssetCategory } from '../models/asset-category.model';
import { AssetCategoryService } from 'src/app/services/asset-category.service';
import { StorageService } from 'src/app/services/storage.service';

export class AssetCategoryStateModel {
    is_refreshing: boolean
    asset_category: AssetCategory[]
}

@State<AssetCategoryStateModel>({
    name: 'asset_category',
    defaults: {
        is_refreshing: true,
        asset_category: []
    }
})
@Injectable()
export class AssetCategoryState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private asset_categoryService: AssetCategoryService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<AssetCategoryStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                       
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }   

    async ngxsOnChanges(change: NgxsSimpleChange) {                     
        if (this.storageService.is_initialized) {
            const state_model: AssetCategoryStateModel = change.currentValue
            this.storageService.set('asset_categorys', JSON.stringify(state_model))   
        }  
    }

    async reloadStateFromStorage() {        
        const json: string = await this.storageService.get('asset_categorys');        
        if (json) {
            const state_model: AssetCategoryStateModel = JSON.parse(json)            
            if (state_model) {                
                this.store.dispatch(new AssetCategoryActions.Init(state_model));
                return
            } 
        }
        this.store.dispatch(new AssetCategoryActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.asset_categoryService.getAll()    
        if (objs != null) {
          const many = AssetCategory.buildMany(objs)                  
          this.store.dispatch(new AssetCategoryActions.Set(many))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: AssetCategoryStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: AssetCategoryStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: AssetCategoryStateModel) {
        return state.asset_category
    }

    @Action(AssetCategoryActions.Refresh)
    async refresh({patchState}: StateContext<AssetCategoryStateModel>, {  }:AssetCategoryActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(AssetCategoryActions.Init)
    init({setState, getState}: StateContext<AssetCategoryStateModel>, { payload }:AssetCategoryActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new AssetCategoryActions.Refresh())
    }
    
    @Action(AssetCategoryActions.Set)
    set({setState}: StateContext<AssetCategoryStateModel>, { payload }:AssetCategoryActions.Set) {             
        setState({   
            is_refreshing: false,         
            asset_category: payload
        })
    }
}
